import { toast } from "react-toastify";
import copy from "copy-to-clipboard";
import ReactTooltip from 'react-tooltip';

import ContentLoading from "../common/ContentLoading";
import Maybe from "../common/Maybe";
import { ReactComponent as IconCopy } from "assets/images/icons/project-icons/copy.svg";
import { ReactComponent as IconInfo } from "assets/images/icons/icon-info-new.svg";


const AccountInfo = (props) => {
    const {loading, label, data, textToCopy, showCopyIcon, showInfoIcon, oldAccount} = props;
    
    const copyText = () => {
        let content = data;
        if (textToCopy){
            content = textToCopy;
        }
        copy(content);
        toast.success("Copied: " + content);
    }
    
    return (
        <div className="">
            <div className="">
                <div className="text-[#717171] flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                        <p>{label}</p>
                        {oldAccount?.oldBankName && <p className="text-[#B42318] bg-[#FEF3F2] rounded-2xl py-0.5 px-2.5">Old Account</p>}
                    </div>
                    <Maybe condition={showInfoIcon === true}>
                    <button type="button" className="w-5 h-5" data-tip data-for="old-account"><IconInfo /></button>
                        <ReactTooltip id="old-account" place="top" effect="solid" className="custom-tooltip" offset={{ top: 10, left: 10 }}>
                            <p className="text-[14px]">
                                We have switched our accounts provider to Stanbic IBTC. Please <br /> 
                                note that Providus accounts will no longer be available from 1st <br />
                                September 2024. <br />
                                Kindly update all your financial workflows accordingly.
                            </p>
                        </ReactTooltip>
                    </Maybe>
                </div>
                <div className={`mt-0.5 font-medium flex items-center ${label === "Account Number" ? "text-2xl" : ""}`}>
                    <ContentLoading
                        loading={loading}
                        data={data}
                    />
                    <Maybe condition={loading === false && data}>
                        <Maybe condition={showCopyIcon === true}>
                            <IconCopy onClick={copyText} className="text-ep-primary-600 ml-3 cursor-pointer w-6 h-6" />
                        </Maybe>
                    </Maybe>
                </div>
            </div>
        </div>
    )
}


export default AccountInfo;